import { useEffect } from 'react';
import { useMutation } from 'urql';
import { toast } from 'sonner';

import { useUser } from '@/components/auth-provider';
import { logoutQuery } from '@/ui/navbar';

export default function LogoutScreen() {
  const [, logout] = useMutation(logoutQuery);
  const { clearUser } = useUser();

  useEffect(() => {
    const performLogout = async () => {
      try {
        const result = await logout();

        if (result.data?.logout) {
          clearUser();
        } else {
          throw new Error();
        }
      } catch (error) {
        toast.error('Logout failed');
      }
    };

    performLogout();
  }, [clearUser, logout]);

  return null;
}
